module.exports = __webpack_public_path__ + "img/168.5b26c7c0.jpg";